import ENV from "@/utils/env";
import { api } from "@/lib/api";
import { useEffect, useRef, useState } from "react";
import { Payload } from "@/api/auth/types/payload.type";

/*
 * This hook is used to validate the auth code returned via the Auth0 callback.
 *
 * Access codes are single use, we use a hook to avoid accidently redeeming it
 * twice.
 */
export const useValidateAuthCode = () => {
  /* State */
  const [error, setError] = useState<boolean>(false);
  const [authRes, setAuthRes] = useState<Payload | null>(null);

  /* Consts */
  const code = history.state?.code;

  // The below ref is a workaround to prevent useEffect from firing multiple times in strict mode
  // due to the code supplied by the auth callback is only valid once
  const hasFired = useRef(false);

  /* Side Effects */
  useEffect(() => {
    const validateAuthCode = async (auth0Code: string) => {
      api
        .post(`${ENV.API_PLATFORM_URL}/manage/auth0/exchange`, {
          code: auth0Code,
          redirectUri: ENV.AUTH0_CALLBACK_URL,
          clientId: ENV.AUTH0_CLIENT_ID,
        })
        .then((res) => {
          setAuthRes(res.data.payload);
        })
        .catch((error) => {
          setError(true);
          return error;
        });
    };

    if (code && !hasFired.current) {
      hasFired.current = true;
      validateAuthCode(code);
    }
  }, [code]);

  /* Render */
  return { authRes, code, error };
};
